import { render, staticRenderFns } from "./ClientsEdit.vue?vue&type=template&id=59b5bd4b&"
import script from "./ClientsEdit.vue?vue&type=script&lang=js&"
export * from "./ClientsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClientsEdit.vue?vue&type=style&index=0&id=59b5bd4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports